import _ from 'underscore';

export default {
    activeDashboardId: null,
    _openNavItems: [],

    /**
     * Setup an event handler for the MAIN_NAV_EXPAND_COLLAPSE event, with the given callback function and refresh interval
     * @param handler {Function} - the callback method to be executed while the main nav expands/collapses
     * @param interval {Number} - the interval at which to execute the handler function - defaults to 20ms
     */
    setExpandCollapseHandler: function(handler, interval) {
        if (!_.isFunction(handler)) {
            throw 'Error MainNavUtil.js - setNavExpandCollapseHandler: the provided handler is not a function';
        }

        $('.main-nav').on('MAIN_NAV_EXPAND_COLLAPSE', this._triggerHandler.bind(this, handler, interval));
    },

    _triggerHandler: function(handler, intervalValue) {
        handler();

        var int = intervalValue || 20,
            interval = setInterval(
                function() {
                    handler();
                }.bind(this),
                int
            );

        setTimeout(function() {
            clearInterval(interval);
        }, 300);
    },

    removeExpandCollapseHandlers: function() {
        $('.main-nav').off('MAIN_NAV_EXPAND_COLLAPSE');
    },

    /**
     * Adds/removes the given $element into the list of open nav items
     * @param $element - jQuery element
     */
    saveToggledNavItem: function($element) {
        if (this._openNavItems.indexOf($element) !== -1) {
            this._openNavItems = _.without(this._openNavItems, $element);
        } else {
            this._openNavItems.push($element);
        }
    },

    /**
     * Loops through the saved opened nav items and actually opens them. This method is called whenever the main nav is expanded
     */
    handleOpenedNavItems: function() {
        _.each(
            this._openNavItems,
            function($menuItem) {
                if (!$menuItem.hasClass('open-main-nav-menu')) {
                    $menuItem
                        .addClass('open-main-nav-menu')
                        .find('.main-nav-menu')
                        .slideDown(200);
                }
            }.bind(this)
        );
    }
};
